import { useContext, useEffect, useMemo, useState } from 'react';
import axiosPrivate from '../../../hooks/axiosPrivate';
import ReactSelect from 'react-select';
import AlertContext from '../../../context/Alert/AlertContext';
import './index.css';
import { toast } from 'react-toastify';
import UploadButton from './UploadButton';

export default function CircularProducts({ circulars = [] }) {
  const [products, setProducts] = useState([]);
  const [selectedCircular, setSelectedCircular] = useState(null);
  const [rates, setRates] = useState([]);
  const { alertMessage, setAlertMessage } = useContext(AlertContext);
 

  const handleFileUpload = (file) => {
    console.log('Uploaded file:', file);
    const formData = new FormData();
    formData.append('file', file);
    axiosPrivate
      .post(`circular/upload-sheet`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Set the correct content type for file uploads
        },
      })
      .then((res) => {
        setAlertMessage({
          message: 'Circular wise product Update Successfully',
        });
        fetchCircularStock()
      })
      .catch((error) => {
        setRates([]);
      });
    // Add logic to upload the file to the server
  };

  useEffect(() => {
    // axiosPrivate.get('dealers').then((dealers) => {
    //   setDealers(dealers?.data?.data);
    // });
    axiosPrivate
      .get('stocks')
      .then((order) => {
        setProducts(order?.data?.data);
      })
      .catch((error) => {});
  }, []);

  const fetchCircularStock = async () => {
    if (selectedCircular) {
      axiosPrivate
        .get(`circular/stocks/${selectedCircular?.value}`)
        .then((res) => {
          setRates(res?.data?.data || []);
        })
        .catch((error) => {
          setRates([]);
        });
    }
  }

  useEffect(() => {
    fetchCircularStock();
  }, [selectedCircular]);

  const circularOptions = useMemo(() => {
    return circulars.map((circular) => ({
      value: circular.id,
      label: circular.name,
    }));
  }, [circulars]);




  async function downloadCircularSheet() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}circular/export/${selectedCircular?.value}`,
        {
          method: 'GET',
          headers: {
            Accept:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to download Excel sheet');
      }

      const blob = await response.blob(); // Get the binary blob
      const url = window.URL.createObjectURL(blob); // Create a download link

      const link = document.createElement('a');
      link.href = url;
      link.download = 'stocks.xlsx'; // You can dynamically name it if needed
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url); // Cleanup
    } catch (error) {
      console.error('Error downloading Excel:', error);
      alert('Download failed!');
    }
  }

  const customStyles = {
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#767676' : 'white',
      color: state.isSelected ? 'white' : 'black',
      '&:hover': {
        backgroundColor: state.isSelected ? '#767676' : '#e0e0e0',
      },
    }),
    control: (base) => ({
      ...base,
      borderColor: '#ddd',
      boxShadow: 'none',
      '&:hover': { boxShadow: '0px 0px 2px 2px #d6d4dd' },
    }),
  };

  useEffect(() => {
    if (alertMessage != null) {
      toast(alertMessage.message, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
      setAlertMessage(null);
    }
  }, [alertMessage, setAlertMessage]);
  return (
    <>
      {/* hearder breadcrumb */}
      <div className='card-header'>
        <strong className=''>Circular Wise Product Rates</strong>
      </div>
      <div className='card'>
        <div className='row dealer-box'>
          <div
            className='col-12 submit-btn my-2'
            style={{ display: 'flex', justifyContent: 'end', gap: '10px' }}
          >
            <button
              disabled={!selectedCircular}
              type='submit'
              className='btn btn-primary ml-2'
              onClick={downloadCircularSheet}
            >
              Export Sheet
            </button>
            <UploadButton onFileUpload={handleFileUpload} />
          </div>

          <div className='col-lg-4 col-md-4 col-sm-12'>
            <div className='form-group'>
              <label>
                Circulars :<span className='required'>*</span>
              </label>
              <ReactSelect
                id='dealer_id'
                styles={customStyles}
                name='dealer_id'
                options={circularOptions}
                value={selectedCircular}
                onChange={(selectedOption) => {
                  setSelectedCircular(selectedOption);
                }}
                placeholder='Select Circular'
                isSearchable
              />
            </div>
          </div>
        </div>
        {!selectedCircular && (
          <p className='not-select'>Please Select Dealer to Export Sheet</p>
        )}

        {selectedCircular && (
          <div className='table-container'>
            <table className='custom-table'>
              <thead>
                <tr>
                  <th>
                    <label>Product</label>
                  </th>
                  <th>
                    <label>Rate</label>
                  </th>
                </tr>
              </thead>
              <tbody>
                {products?.map((product, index) => (
                  <tr key={product.id}>
                    <td>
                      <label>{product?.tally_name}</label>
                    </td>
                    <td>
                      <label>
                        {rates.find(
                          (rate) =>
                            rate.circular_id === selectedCircular.value &&
                            rate.stock_id === product.id
                        )?.rate || 'Not Assigned'}
                      </label>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
